import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import EditIcon from '@/components/icons/EditIcon.vue'
import DeleteIcon from '@/components/icons/DeleteIcon.vue'
import DisplayIcon from '@/components/icons/DisplayIcon.vue'
import Verte from 'verte'
import 'verte/dist/verte.css';

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(EditIcon.name, EditIcon)
Vue.component(DeleteIcon.name, DeleteIcon)
Vue.component(DisplayIcon.name, DisplayIcon)
Vue.component('verte', Verte);
